import React, { Component } from "react";
import { connect } from "react-redux";
import { logoutUser } from "../../actions";
import { Redirect } from "react-router";

class Logout extends Component {
    constructor(props) {
        super(props);
    }

    handleLogout = () => {
        const { dispatch } = this.props;
        dispatch(logoutUser());
    };

    render() {
        const { isLoggingOut, logoutError } = this.props;
        this.handleLogout();
        return(
            <Redirect to = "/login"/>
        );
    }
}

function mapStateToProps(state) {
    return {
        isLoggingOut: state.auth.isLoggingOut,
        logoutError: state.auth.logoutError
    };
}

export default connect(mapStateToProps)(Logout);
